__turbopack_context__.v({
  "input": "mantineTextarea-module-scss-module__HDPDTq__input",
});
